<template>
  <v-layout row wrap class="white border-radius-standard px-0 py-2">
    <slot name="title">
      <v-flex xs12>
        <div class="title-icon">
          <span class="botter-mask-group-44-icon white--text text-lg-2 icon-holder primary" />
          <span class="title-content">Interactive Template Message</span>
        </div>
      </v-flex>
    </slot>
    <v-flex v-if="loader.template" xs12 class="mt-1" style="display: flex">
      <v-progress-circular
        :rotate="360"
        :size="120"
        :width="15"
        indeterminate
        color="primary"
        style="margin: auto"
        >Loading Template</v-progress-circular
      >
    </v-flex>
    <v-flex v-if="!loader.template" xs12 class="mt-1">
      <h4 class="template-subtitle">Header (Optional)</h4>
      <label class="grey--text">Choose Media Type</label>
    </v-flex>
    <v-flex v-if="!loader.template" xs12 class="px-0">
      <v-radio-group v-model="input.header" row wrap class="headers-wrapper" :disabled="disabled">
        <v-radio
          v-for="(head, h) in headerOptions"
          :key="h"
          :value="head.value"
          :disabled="disabled"
          class="header-option"
          color="green lighten-1"
        >
          <v-layout slot="label" row wrap class="header-content" align-center justify-center>
            <v-flex xs12 class="text-center py-0 my-0">
              <span :class="[
              {'primary--text': !disabled },
              {'dimmed-primary-text': disabled},
              'header-icon',
              `botter-${head.icon}-icon`]" />
            </v-flex>
            <v-flex xs12 :class="['py-0 my-0', { 'primary--text': !disabled}, {'dimmed-primary-text': disabled}]">
              <p class="text-center my-0 py-0">{{ head.text }}</p>
            </v-flex>
          </v-layout>
        </v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex v-if="input.header && input.header === 'TEXT' && !loader.template && !showOnly" class="animated fadeIn" xs12>
      <label class="grey--text">Title</label>
      <v-text-field
        v-model="input.headerTitle"
        :disabled="disabled"
        placeholder="Header"
        class="field-width"
        outline
      />
    </v-flex>
    <slot name="header-append" />
    <!-- body starts -->
    <v-flex v-if="!loader.template && !showOnly" xs12 class="mt-0 animated fadeIn">
      <h4 class="template-subtitle">Body</h4>
      <label class="grey--text">Type text of your message in language you’ve selected</label>
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12 class="pb-0 mb-0 animated fadeIn">
      <v-textarea
        v-model="input.body"
        :disabled="disabled"
        placeholder="Type Your message here.."
        class="field-width"
        :counter="1024"
        outline
      />
    </v-flex>
    <!-- body ends -->
    <!-- footer starts -->
    <v-flex v-if="!loader.template && !showOnly" xs12 class="mt-0 animated fadeIn">
      <h4 class="template-subtitle">Footer (Optional)</h4>
      <label class="grey--text">Add a-short line of text to bottom of your message</label>
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12>
      <v-text-field
        v-model="input.footer"
        :disabled="disabled"
        placeholder="Footer"
        class="field-width"
        outline
      />
    </v-flex>
    <!-- footer ends -->
    <!-- buttons starts -->
    <v-flex v-if="!loader.template && !showOnly" xs12 class="mt-0 animated fadeIn">
      <h4 class="template-subtitle">Buttons (Optional)</h4>
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12 class="px-0 animated fadeIn">
      <v-radio-group
        v-model="buttonsType"
        row
        wrap
        class="buttons-radio-gp px-0 field-width"
        :disabled="disabled"
      >
        <v-radio
          v-for="(head, h) in buttonsOptions"
          :key="h"
          :value="head.value"
          :disabled="disabled"
          :class="['button-option', { disabled: disabled }]"
          color="green lighten-1"
          @click="buttonsType = head.value"
        >
          <div slot="label" :class="{ 'primary--text': !disabled }">{{ head.text }}</div>
        </v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12 class="animated fadeIn">
      <label class="grey--text field-width"
        >Create up to 2 buttons that let customer respond to your message Or take actions</label
      >
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12 class="animated fadeIn">
      <template-message-buttons v-model="buttons" :type="buttonsType" :disabled="disabled" />
    </v-flex>
    <!-- buttons ends -->
  </v-layout>
</template>

<script>
import TemplateMessageButtons from './TemplateMessageButtons';
import TemplateViewer from './TemplateViewer';
export default {
  name: 'TemplateMessageEditor',
  components: {
    TemplateMessageButtons,
    TemplateViewer,
  },
  props: {
    templateId: {
      type: String,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    showOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateData: null,
      buttons: [],
      headerOptions: [
        { value: null, icon: 'none', text: 'None' },
        { value: 'TEXT', icon: 'font', text: 'Text' },
        { value: 'IMAGE', icon: 'image1', text: 'Image' },
        { value: 'DOCUMENT', icon: 'doc', text: 'Document' },
      ],
      buttonsOptions: [
        { value: null, text: 'None' },
        { value: 'quickReply', text: 'Quick Reply' },
        { value: 'actions', text: 'Actions' },
      ],
      input: {
        header: null,
        headerTitle: '',
        body: '',
        footer: '',
        buttons: [],
      },
      buttonsType: null,
      loader: {
        template: false,
      },
    };
  },
  computed: {
    disabled() {
      return (this.templateData && (this.templateData.status === 'APPROVED'|| this.templateData.status === 'PENDING')) || this.disable
    },
    componentsValue() {

      let temp = {};
      const result = [];

      if (this.buttons && this.buttons.length) {
        result.push({
          type: 'BUTTONS',
          buttons: this.buttons,
        });
      }

      
      if (this.input.header) {
        temp = {
          type: 'HEADER',
          format: this.input.header,
        };
        if (temp.format === 'TEXT') {
          temp.text = this.input.headerTitle;
        }
        result.push(temp);
      }

      result.push({
        type: 'BODY',
        text: this.input.body,
      });

      if (this.input.footer && this.input.footer.length) {
        result.push({
          type: 'FOOTER',
          text: this.input.footer,
        });
      }



      return result;
    },
  },
  watch: {
    buttons: {
      deep: true,
      immediate: true,
      handler(val) {
        this.input.buttons = val
      }
    },
    componentsValue: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      },
    },
    templateData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit('info', val);
      },
    },
    templateId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTemplateData();
        }
      },
    },
  },
  mounted() {
    this.getTemplateData();
  },
  methods: {
    getTemplateData() {
      this.loader.template = true;
      this.$http_chat
        .get(`/template-message/${this.templateId}`)
        .then((res) => {
          this.$store.dispatch('setLoader', false);
          this.templateData = res.data;
          if (res.data.components) {
            const components = res.data.components;
            // handle header
            let header = components.filter((c) => c.type === 'HEADER');
            if (header && header.length) {
              header = header[0];
              this.input.header = header.format;
              if (header.format === 'TEXT') {
                this.input.headerTitle = header.text;
              }
            }
            // handle body
            let body = components.filter((c) => c.type === 'BODY');
            if (body && body.length) {
              body = body[0];
              this.input.body = body.text;
            }
            // handle footer
            let footer = components.filter((c) => c.type === 'FOOTER');
            if (footer && footer.length) {
              footer = footer[0];
              this.input.footer = footer.text;
            }
            // handle buttons
            let buttons = components.filter((c) => c.type === 'BUTTONS');
            if (buttons && buttons.length) {
              buttons = buttons[0];
              if (buttons.buttons.length) {
                this.buttonsType =
                  buttons.buttons[0].type === 'QUICK_REPLY' ? 'quickReply' : 'actions';
              }
              // this.input.buttons = buttons.buttons;
              this.buttons = buttons.buttons
            }
          }
          this.loader.template = false;
        })
        .catch(() => {
          this.$store.dispatch('setLoader', false);
          this.$store.dispatch('setErrorMessage', true);
          this.loader.template = false;
        });
    },
    save() {
      this.$store.dispatch('setLoader', true);
      this.$http_chat
        .put(`/template-message/${this.templateId}/save`, { components: this.componentsValue })
        .then(() => {
          this.$store.dispatch('setLoader', false);
        })
        .catch(() => {
          this.$store.dispatch('setLoader', false);
          this.$store.dispatch('setErrorMessage', true);
        });
    },
  },
};
</script>

<style lang="scss">
.dimmed-primary-text {
  color: rgba(55, 47, 172, 0.3);
}
.header-col {
}
.header-option {
  width: 100px;
  height: 100px;
  padding: 3px;
  border-radius: 8px;
  border: 1px dashed #ccc;
  background-color: #f4f5f9;
  display: block;
}
.header-content {
  width: 100px;
  margin-left: -3px;
}
.title-icon {
  .icon-holder {
    border-radius: 8px;
    padding: 3px;
  }
  .title-content {
    padding-left: 5px;
    vertical-align: super;
    font-size: 16px;
  }
}
.template-subtitle {
  font-size: 16px;
  font-weight: bold;
  padding-top: 4px;
}
.button-option {
  border: 1px solid #372fac;
  border-radius: 8px;
  padding: 10px 5px;
  width: 30%;
  justify-content: center;
  cursor: pointer;
  margin-left: 0px;
  margin-right: 4px;
  &.disabled {
    border-color: #ccc;
  }
}
.buttons-radio-gp {
  .v-input__control {
    width: 100%;
  }
}
.field-width {
  width: 410px;
}
.template-msg-editor {
  border-right: 2px dashed #f4f5f9;
}
.template-title {
  font-weight: bold;
  font-size: 22px;
}
.header-icon {
  font-size: 24px;
}
</style>
